module.exports = __webpack_public_path__ + "img/step47_3-people.69727eff.png";